import styled from 'styled-components/macro';
import { BORDER_RADIUS } from 'utils/baseStyleSizes';
import { deviceMin, deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const Container = styled.div`
  width: 474px;
  height: 586px;
  border-radius: 8px;
  position: relative;

  @media ${deviceMin.mobileS} {
    width: 270px;
    height: auto;
  }

  @media ${deviceMin.mobileL} {
    width: 348px;
  }

  @media ${deviceMin.tablet} {
    width: 270px;
  }

  @media ${deviceMin.laptopL} {
    width: 308px;
  }

  @media ${deviceMin.desktop} {
    width: 474px;
  }

  .image {
    border-radius: 10px 10px 0 0;
    width: 474px;
    height: 586px;

    @media ${deviceMin.mobileS} {
      width: 270px;
      height: auto;
      margin-left: 0;
    }

    @media ${deviceMin.mobileL} {
      width: 348px;
      height: auto;
    }

    @media ${deviceMin.tablet} {
      width: 270px;
      height: 264px;
    }

    @media ${deviceMin.laptopL} {
      width: 308px;
      height: 316px;
    }

    @media ${deviceMin.desktop} {
      width: 474px;
      height: 432px;
    }
  }

  .mobile-description {
    @media ${deviceMin.mobileS} {
      display: block;
      margin-top: 12px;
      padding: 0 16px;
    }

    @media ${deviceMin.tablet} {
      display: none;
      margin-top: 0;
    }
  }

  .priceWrapper {
    ${FONT_FAMILY.FontMedium}
    color: ${COLORS.blue};
    font-style: normal;
    ${FONTS.font36}
    margin-right: 18px;

    @media ${deviceMin.mobileS} {
      display: none;
    }

    @media ${deviceMin.tablet} {
      display: block;
      ${FONTS.font24}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font36}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font36}
    }
  }
`;

export const CardItem = styled.div`
  ${FLEX_CONTAINER.FlexRow};

  @media ${deviceMin.mobileS} {
    ${FLEX_CONTAINER.FlexColumn}
    margin-top: 24px;
  }

  @media ${deviceMin.tablet} {
    ${FLEX_CONTAINER.FlexRow}
    margin-top: 38px;
  }

  @media ${deviceMin.laptopL} {
    margin-top: 50px;
  }

  @media ${deviceMin.desktop} {
    margin-top: 70px;
  }

  .cardWrapper {
    width: 474px;
    height: 586px;
    border-radius: 25px;
    position: relative;

    @media ${deviceMin.mobileS} {
      width: 260px;
      height: auto;
    }

    @media ${deviceMin.tablet} {
      width: 270px;
      height: 372px;
    }

    @media ${deviceMin.laptopL} {
      width: 308px;
      height: 424px;
    }

    @media ${deviceMin.desktop} {
      width: 474px;
      height: 586px;
    }
  }
`;

export const StyledButton = styled.button`
  &:hover {
    background: ${COLORS.mainColor_op7};
  }
`;

export const Info = styled.div`
  background: ${COLORS.lightGray};
  width: 100%;
  height: 92px;
  bottom: 0;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  padding-bottom: 22px;
  position: relative;

  @media ${deviceMin.mobileS} {
      height: auto;
  }
  @media ${deviceMin.tablet} {
     margin-top: 0;
     height: auto;
     bottom: 24px;
  }
  @media ${deviceMin.laptopL} {
    
    margin-top: 0;
    margin-bottom: 0;
  }
  @media ${deviceMin.desktop} {
    
    margin-top: 0;
  }

  .buttonWrapper {
    @media ${deviceMin.mobileS} {
      display: block;
    }
    @media ${deviceMin.tablet} {
      display: none;
    }
  }

  .Info-wrapper {
    ${FLEX_CONTAINER.FlexSpaceBetweenRow}
    width: 100%;
    height: 92px;
  }
`;

export const InfoSection = styled.div`
  align-items: unset;
  margin-left: 32px;
  @media ${deviceMin.mobileS} {
    display: none;
  }

  @media ${deviceMin.tablet} {
    ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
    margin-left: 34px;
    align-items: unset;
    height: 340px;
  }

  @media ${deviceMin.laptopL} {
    margin-left: 56px;
    align-items: unset;
    height: 400px;
  }

  .title {
    ${FONT_FAMILY.FontMedium}

    @media ${deviceMin.tablet} {
      ${FONTS.font16}
      margin-bottom: 14px;
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font20}
      margin-bottom: 24px;
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font24};
      margin-bottom: 30px;
    }
  }

  .starsinfo {
    @media ${deviceMin.tablet} {
      width: 90px;
      height: 14px;
      margin-bottom: 14px;
    }

    @media ${deviceMin.laptopL} {
      width: 104px;
      height: 17px;
      margin-bottom: 14px;
    }

    @media ${deviceMin.desktop} {
      width: 104px;
      height: 17px;
      margin-bottom: 24px;
      margin-left: 0;
    }
  }

  .desc {
    color: ${COLORS.blueBlack};
    @media ${deviceMin.tablet} {
      ${FONTS.font14}
    }
    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }
    @media ${deviceMin.desktop} {
      ${FONTS.font16}
    }
  }
`;

export const SeeMore = styled.div`
  button {
    width: 218px;
    height: 54px;
    background: ${COLORS.mainColor};
    border-radius: ${BORDER_RADIUS.radius14};
    color: ${COLORS.white};
    ${FONTS.font24}
    ${FONT_FAMILY.FontMedium}

    &:hover {
      background: ${COLORS.mainColor_op7};
      border: none;
    }

    @media ${deviceMin.mobileS} {
      width: 194px;
      height: 48px;
      ${FONTS.font20}
      margin-top: 36px;
    }

    @media ${deviceMin.tablet} {
      margin-top: 50px;
      width: 194px;
      height: 48px;
      ${FONTS.font20}
      margin-bottom: 0;
    }

    @media ${deviceMin.laptopL} {
      width: 194px;
      height: 48px;
      ${FONTS.font20}
    }

    @media ${deviceMin.desktop} {
      width: 218px;
      height: 54px;
    }
  }

  @media ${deviceMax.tablet} {
    margin-left: 16px;
  }
`;

export const Title = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  width: 208px;
  height: 64px;
  position: absolute;
  top: 0;
  background: ${COLORS.mainColor};
  border-radius: 10px 0 0 0;

  span {
    text-align: center;
    ${FONTS.font16}
    color: ${COLORS.white};

    @media ${deviceMin.tablet} {
      ${FONTS.font12}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font14}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font16}
    }
  }

  span {
    text-align: center;
    ${FONT_FAMILY.FontMedium}
    ${FONTS.font20}
    color: ${COLORS.white};

    @media ${deviceMin.tablet} {
      ${FONTS.font14}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font20}
    }
  }
`;
export const LeftSide = styled.div`
  ${FLEX_CONTAINER.FlexColumn}
  width: 155px;
  height: 92px;
  margin-top: 12px;

  p {
    ${FONT_FAMILY.FontMedium}
    ${FONTS.font24};
    margin-top: 10px;

    @media ${deviceMin.mobileS} {
      ${FONTS.font16}
    }

    @media ${deviceMin.tablet} {
      ${FONTS.font16}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font24};
    }
  }
  .stars {
    width: 120px;
    height: 22px;
    object-fit: contain;
    margin-left: 20px;
    margin-top: 10px;
  }
`;
